import { render, staticRenderFns } from "./Sorteos.vue?vue&type=template&id=789de348&scoped=true"
import script from "./Sorteos.vue?vue&type=script&lang=js"
export * from "./Sorteos.vue?vue&type=script&lang=js"
import style0 from "./Sorteos.vue?vue&type=style&index=0&id=789de348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789de348",
  null
  
)

export default component.exports